
import v3patform from './v3platform'
import { SSL_OP_NETSCAPE_REUSE_CIPHER_CHANGE_BUG } from 'constants';

const columnHandlerKey = '___$ColumnChangeHandler___';
/**
 * {
	prop:{
		//属性名称
		name:'dataSource',
		//是否必填
		required:true/false,
		//默认值
		default:[],
		//校验函数
		validator:function
	},
	event:{
		//数据加载事件
		load:false/true/{
			name:'on-load'
		},
		//数据变化事件
		change:false/true/{
			name:'on-change',
			handler:
		},
		//记录切换事件
		currentChange:false/true/{
			name:'on-current-change'
		},
		//记录选择变更事件
		selectionChange:false/true/{
			name:'on-selection-change'
		}
	}
}
{
	props:{
		dataSource:{
			type:Array,
			v3PropType:'datasource'
			required:options.required,
			default:[],
			validator:options.validator
		}
	},
	created:function(){
		1、注册数据源加载事件LOAD
		2、注册数据源记录切换事件CURRENT
		3、注册数据源数据变化事件UPDATE
		4、注册记录选择变更事件SELECT
	},
	methods:{
		1、设置当前行
		2、设置选中记录
		....
	}
}
 * 
*/
function DatasourceMixin(params){
	var mixin = getMixin(params,"datasource");
	return mixin;
}

/**
 * 
 * @param {*} params 
 */
var RecordMixin = function(params){
	var mixin = getMixin(params,"record");
	return mixin;
}
/**
 * 
 * @param {*} params 
 */
var CellMixin = function(params){
	if(!params){
		params = {
			prop : {
				name:"value"
			}
		}
	}else if(!params.prop){
		params.prop = {
			name : "value"
		};
	}else{
		params.prop.name = "value"; 
	}

	var mixin = getMixin(params,"cell");
	mixin.watch = {
		value : function(newVal, oldVal){
			this.$emit('input', newVal);
		}
	}
	return mixin;
}
var getMixin = function(params, type){
	var result = {};
	if(check(params, type)){
		// 合并默认参数
		params = mergeDefaultParams(params, type);
		var props = getProps(params.prop,type);
		//获取create钩子函数
		var createFunc = getCreateFunc(params,type);
		var methods = getMethods(params, type);
		result = {
			props : props,
			// beforeCreate : createFunc,
			created : createFunc,
			data : function(){
				return {
					V3_PLATFORM_ENTITY_DATAS_INFO_IDEN:{}//本地实体数据处理信息,非数据源，不可存数组值，因为其他接口无数据源名称，需遍历数组值
				}
			},
			methods: methods
        }
	}
	return result;
}
function mergeDefaultParams (params, type) {
	var defaultParams = getDefaultParams(type);
	for (var propKey in params.prop) {
		defaultParams.prop[propKey] = params.prop[propKey];
	}
	for (var eventKey in params.event) {
		defaultParams.event[eventKey] = params.event[eventKey];
	}
	return defaultParams;
}
function getDefaultParams(type) {
	var defaultParams = {
		datasource: {
			prop: {
				required: true,
				default: []
			},
			event: {
				"load": true,
				"change": true,
				"currentChange": true,
				"selectionChange": true
			}
		},
		record: {
			prop: {
				required: true,
				default: {}
			},
			event: {
				"load": true,
				"change": true
			}
		},
		cell: {
			prop: {
				required: true,
				default: {}
			},
			event: {
				"load": true,
				"change": true
			}
		}
	}
	return defaultParams[type];
}
function getMethods(params, type) {
	var methodsList = {
		'datasource': [
			'isCurrent',
			'isSelected', 
			'markCurrent', 
			'markSelected', 
			'markUnSelect', 
			'getDatasourceName', 
			'getCurrentRecord',
			'getSelectedRecords',
			'v3PlatformFireEvent',
			'markDatasourceMultipleSelect',
			'registerColumnChangeHandler'
		]
	}
	var propName = params.prop.name;
	var methods = {};
	var appointMethods = methodsList[type];
	if (appointMethods) {
		for (var i = 0, l = appointMethods.length; i < l; i++) {
			var key = appointMethods[i];
			var method = getMethod(key, propName);
			methods[key] = method;
		}
	}
	return methods;
}
function getMethod(key, propName) {
	var setSelectRecords = function (_this, records, isSelected) {
		if (records instanceof Array) {
			var recordsLength = records.length;
			if (recordsLength > 0) {
				if(isRunInV3Service(_this)){
					var dsName = null;
					if (records[0]._metadata_) {
						dsName = records[0]._metadata_.dsName;
					} else {
						throw new Error('无法获取实体编码')
					}
					for (var i = 0; i < recordsLength; i++) {
						var record = records[i];
						if (record) {
							v3patform.synSelectRecordToDs(_this, dsName, record, isSelected);
						} else {
							throw new Error('行记录不存在，无法设置为选中状态');
						}
					}
				}else{
					var entityInfo = _this.V3_PLATFORM_ENTITY_DATAS_INFO_IDEN[propName];
					var selectedRecords = entityInfo.selectedRecords;
					if(isSelected === true){
						var record = records[0];
						if(_this.isMultipleSel === true){
							var hasChange = false;
							for(var i = 0,len = records.length;i<len;i++){
								var record = records[i];
								if(selectedRecords.indexOf(record) == -1){
									selectedRecords.push(record);
									hasChange = true;
								}
							}
							if(hasChange){
								//触发选中行改变
								_this.v3PlatformFireEvent(_this, entityInfo.selectionChange, [entityInfo.selectedRecords]);
							}
						}else{
							if(records.length > 1){
								v3patform.v3Log("warn","非多选数据源，不支持设置多个选中，已选第一条作为选中记录");
							}
							if(record != entityInfo.currentRecord){
								entityInfo.currentRecord = record;
								entityInfo.selectedRecords = [record];
								//触发当前行改变事件
								_this.v3PlatformFireEvent(_this, entityInfo.currentChange, [entityInfo.currentRecord]);
								//触发选中行改变
								_this.v3PlatformFireEvent(_this, entityInfo.selectionChange, [entityInfo.selectedRecords]);
							}
						}
					}else{
						if(_this.isMultipleSel === true){
							var hasChange = false;
							for(var i = 0,len = records.length;i<len;i++){
								var record = records[i];
								var index = selectedRecords.indexOf(record);
								if (index != -1) {
									hasChange = true;
									selectedRecords.splice(index, 1);
								}
							}
							if(hasChange){
								//触发选中行改变
								_this.v3PlatformFireEvent(_this, entityInfo.selectionChange, [entityInfo.selectedRecords]);
							}
						}else{
							v3patform.v3Log("error","非多选数据源, 不支持取消选中");
						}
					}
				}
			}
		} else {
			throw new Error('标记选中/不选中的数据必须为数组类型，只标记一行数据请用"[]"将数据包装成数组。');
		}
	}
	var notFoundDsName = function () {
		throw new Error('无法获取实体编码');
	}
	/**
	 * 获取实体编码
	 * @param {*} _this 
	 * @param {*} propName 
	 */
	var getDsName = function (_this) {
		if (_this.$options.propsData[propName]._metadata_) {
			return _this.$options.propsData[propName]._metadata_.dsName;
		} else if (_this[propName]._metadata_) {
			return _this[propName]._metadata_.dsName;
		} else if (_this[propName] && _this[propName][0] && _this[propName][0]._metadata_) {
			return _this[propName][0]._metadata_.dsName;
		} else {
			return null;
		}
	}
	var isRunInV3Service = function(_this){
		return v3patform.isRunInV3Service();
	}
	var defaultMethods = {
		'registerColumnChangeHandler': function (field, handler) {
			var _this = this;
			if (_this[columnHandlerKey]) {
				_this[columnHandlerKey][field] = handler;
			} else {
				_this[columnHandlerKey] = {};
				_this[columnHandlerKey][field] = handler;
			}
		},
		'getDatasourceName': function () {
			var _this = this;
			if(isRunInV3Service(this)){
				return getDsName(_this);
			}else{
				if(window.console){
					window.console.warn("本地数据暂不支持获取数据源名称");
				}
				return null;
			}
		},
		'getCurrentRecord' : function(){
			var _this = this;
			if(isRunInV3Service(this)){
				return v3patform.getCurrentRecord(_this, getDsName(_this));
			}else{
				var entityInfo = _this.V3_PLATFORM_ENTITY_DATAS_INFO_IDEN[propName];
				return entityInfo.currentRecord;
			}
		},
		'getSelectedRecords' : function(){
			var _this = this;
			if(isRunInV3Service(this)){
				return v3patform.getSelectedRecords(_this, getDsName(_this));
			}else{
				var entityInfo = _this.V3_PLATFORM_ENTITY_DATAS_INFO_IDEN[propName];
				return entityInfo.selectedRecords;
			}
			return [];
		},
		'markDatasourceMultipleSelect': function () {
			var _this = this;
			if(isRunInV3Service(_this)){//V平台服务
				var dsName = getDsName(_this);
				v3patform.markMultipleDs(_this, dsName);
			}else{//本地数据
				var entityInfo = this.V3_PLATFORM_ENTITY_DATAS_INFO_IDEN[propName];
				entityInfo.isMultipleSel = true;
			}
		},
		'isCurrent': function (data) {
			var _this = this;
			if (typeof data === 'string') {
				if(!isRunInV3Service(this)){
					if(window.console){
						window.console.warn("本地数据不支持根据id判断是否当前行");
					}
					return false;
				}
				var dsName = getDsName(_this);
				if (dsName) {
					var currentRecord = v3patform.getCurrentRecord(_this, dsName);
					var cid = currentRecord.id;
					if (cid) {
						return cid === data;
					} else {
						throw new Error("无法读取当前行记录的id属性，无法校验");
					}
				} else {
					notFoundDsName();
				}
			} else if (typeof data === 'object') {
				if(isRunInV3Service(this)){
					var dsName = data._metadata_.dsName;
					if (dsName) {
						return v3patform.isCurrent(_this, dsName, data);
					} else {
						notFoundDsName();
					}
				}else{
					var entityInfo = this.V3_PLATFORM_ENTITY_DATAS_INFO_IDEN[propName];
					return data == entityInfo.currentRecord;
				}
			} else {
				throw new Error("不支持处理该类型数据，传入数据必须是行记录的id(string)或行记录(object)");
			}
		},
		'isSelected': function (data) {
			var _this = this;
			if (typeof data === 'string') {
				if(!isRunInV3Service(this)){
					if(window.console){
						window.console.warn("本地数据不支持根据id判断是否选中行");
					}
					return false;
				}
				var dsName = getDsName(_this);
				if (dsName) {
					var selectedRecords = v3patform.getSelectedRecords(_this, dsName);
					if (selectedRecords) {
						for (var i = 0, l = selectedRecords.length; i < l; i++) {
							var sid = selectedRecords[i].id;
							if (sid === data) {
								return true;
							}
						}
						return false;
					} else {
						throw new Error("无法获取选中行记录");
					}
				} else {
					notFoundDsName();
				}
			} else if (typeof data === 'object') {
				if(isRunInV3Service(this)){
					var dsName = data._metadata_.dsName;
					if (dsName) {
						return v3patform.isSelected(_this, dsName, data);
					} else {
						notFoundDsName();
					}
				}else{
					var entityInfo = this.V3_PLATFORM_ENTITY_DATAS_INFO_IDEN[propName];
					var selectRecords = entityInfo.selectedRecords;
					if(selectRecords.indexOf(data) != -1){
						return true;
					}
				}
			} else {
				throw new Error("不支持处理该类型数据，传入数据必须是行记录的id(string)或行记录(object)");
			}
		},
		'markCurrent': function (data) {
			var _this = this;
			var dsName = getDsName(_this);
			if (typeof data === 'string') {
				if(!isRunInV3Service(this)){
					if(window.console){
						window.console.warn("本地数据不支持使用id设置选中行");
					}
					return false;
				}
				var ds = _this[propName];
				if (ds) {
					var record = null;
					for (var i = 0, l = ds.length; i < l; i++) {
						var item = ds[i];
						if (item.id === data) {
							record = item;
							break;
						}
					}
					if (record) {
						v3patform.synCurrentRecordToDs(_this, dsName, record);
					} else {
						throw new Error("无法根据ID获取行记录");
					}
				} else {
					throw new Error("无法获取实体");
				}
			} else if (typeof data === 'object') {
				if(isRunInV3Service(this)){
					if(null == dsName){
						if(data._metadata_){
							dsName = data._metadata_.dsName;
						}
					}
					v3patform.synCurrentRecordToDs(_this, dsName, data);
				}else{
					var entityInfo = this.V3_PLATFORM_ENTITY_DATAS_INFO_IDEN[propName];
					entityInfo.currentRecord = data;
					//触发当前行改变事件
					this.v3PlatformFireEvent(this, entityInfo.currentChange, [entityInfo.currentRecord]);
					if(entityInfo.isMultipleSel === false){//非多选，更新选中行
						entityInfo.selectedRecords = [data];
						//触发选中行改变
						this.v3PlatformFireEvent(this, entityInfo.selectedChange, [entityInfo.selectedRecords]);
					}
				}
			} else {
				throw new Error("不支持处理该类型数据，传入数据必须是行记录的id(string)或行记录(object)");
			}
		},
		'markSelected': function (records) {
			var _this = this;
			setSelectRecords(_this, records, true);
		},
		'markUnSelect': function (records) {
			var _this = this;
			setSelectRecords(_this, records, false);
		},
		'v3PlatformFireEvent':function(instance, events, params){
			for (var i = 0, len = events.length; i < len; i++) {
				var event = events[i];
				if (typeof event == "function") {
					event.apply(instance, params);
				}
			}
		}
	}
	return defaultMethods[key];
}

/**
 * 监听字段数据
 * @params {Object} instance vue实例
 * @params {String} dsName 实体名称
 * @params {String} iden 数据表示
 * 
*/
function watchFieldData(instance, dsName, iden){
	var destroy = instance.$watch("V3_PLATFORM_ENTITY_DATAS_INFO_IDEN." + dsName + "." + "datas" + "." + iden,(function(_this, name){
		return function(record){
			debugger;
			var entityInfos = _this.V3_PLATFORM_ENTITY_DATAS_INFO_IDEN[name];
			var changeEvents = entityInfos.change;
			if(changeEvents && changeEvents.length >0){
				for(var i = 0,len = changeEvents.length;i<len;i++){
					var event = changeEvents[i];
					if(typeof(event) == "function"){
						event.apply(_this,[record]);
					}
				}
			}
		}
	})(instance, dsName),{
		deep : true,
		sync : true
	});
	//保存销毁watch的函数
	instance.V3_PLATFORM_ENTITY_DATAS_INFO_IDEN[dsName].destroys[iden] = destroy;
}

/**
 * 处理本地数据的实体事件
 * @params {Array} events 事件列表
 * @params {String} dsName 实体名称
 * @params {Object} instance vue实例
 * 
*/
function handlerLocalEntityCell(events, dsName, instance) {
	var entityInfos = instance.V3_PLATFORM_ENTITY_DATAS_INFO_IDEN;
	if (!entityInfos.hasOwnProperty(dsName)) {
		var dataIden = v3patform.genUUID();
		var entityInfo = {
			datas:{},//数据索引映射 索引 --> 数据
			destroys:{},//销毁数据监听函数
			load: [],
			change: []
		};
		entityInfos[dsName] = entityInfo;
		var datas = entityInfo.datas;
		//初始数据
		var nowRecords = instance[dsName];
		//1、处理实体事件
		if(events){
			for(var i = 0,len = events.length;i<len;i++){
				var event = events[i];
				var type = event.eventType;
				if(entityInfo.hasOwnProperty(type)){
					entityInfo[type].push(event.handler);
				}
			}
		}
		//2、处理实体初始的数据，获得初始数据并监听
		if (nowRecords) {
			//触发加载事件
			fireEvent(instance,entityInfo.load,[nowRecords]);
		}
		instance.$watch(dsName,function(newVal, oldVal){
			var changeEvents = instance.V3_PLATFORM_ENTITY_DATAS_INFO_IDEN[dsName].change;
			if(changeEvents && changeEvents.length > 0){
				for(var i = 0,len = changeEvents.length;i<len;i++){
					var event = changeEvents[i];
					if(typeof(event) == "function"){
						event.apply(instance, [newVal,oldVal]);
					}
				}
			}
		})
	}
}

/**
 * 处理本地数据的实体事件
 * @params {Array} events 事件列表
 * @params {String} dsName 实体名称
 * @params {Object} instance vue实例
 * 
*/
function handlerLocalEntityRecord(events, dsName, instance) {
	var entityInfos = instance.V3_PLATFORM_ENTITY_DATAS_INFO_IDEN;
	if (!entityInfos.hasOwnProperty(dsName)) {
		var dataIden = v3patform.genUUID();
		var entityInfo = {
			datas:{},//数据索引映射 索引 --> 数据
			destroys:{},//销毁数据监听函数
			load: [],
			change: []
		};
		entityInfos[dsName] = entityInfo;
		var datas = entityInfo.datas;
		//初始数据
		var nowRecords = instance[dsName];
		//1、处理实体事件
		if(events){
			for(var i = 0,len = events.length;i<len;i++){
				var event = events[i];
				var type = event.eventType;
				if(entityInfo.hasOwnProperty(type)){
					entityInfo[type].push(event.handler);
				}
			}
		}
		//2、处理实体初始的数据，获得初始数据并监听
		if (nowRecords) {
			//索引标识
			var iden = v3patform.genUUID();
			datas[iden] = nowRecords;
			//监听字段数据
			watchFieldData(instance, dsName, iden);
			//触发加载事件
			fireEvent(instance,entityInfo.load,nowRecords);
		}
	}
}

/**
 * 处理本地数据的实体事件
 * @params {Array} events 事件列表
 * @params {String} dsName 实体名称
 * @params {Object} instance vue实例
 * 
*/
function handlerLocalEntity(events, dsName, instance) {
	var entityInfos = instance.V3_PLATFORM_ENTITY_DATAS_INFO_IDEN;
	if (!entityInfos.hasOwnProperty(dsName)) {
		var dataIden = v3patform.genUUID();
		var entityInfo = {
			datas:{},//数据索引映射 索引 --> 数据
			destroys:{},//销毁数据监听函数
			currentRecord:null,//
			currentRecordDestory:null,
			selectedRecords:[],
			selectedRecordsDestory:null,
			isMultipleSel: false,
			load: [],
			change: [],
			currentChange: [],
			selectionChange: []
		};
		entityInfos[dsName] = entityInfo;
		var datas = entityInfo.datas;
		//初始数据
		var nowRecords = instance[dsName];
		//1、处理实体事件
		if(events){
			for(var i = 0,len = events.length;i<len;i++){
				var event = events[i];
				var type = event.eventType;
				if(entityInfo.hasOwnProperty(type)){
					entityInfo[type].push(event.handler);
				}
			}
		}
		//2、处理实体初始的数据，获得初始数据并监听
		if (nowRecords && nowRecords.length > 0) {
			entityInfo.currentRecord = nowRecords[0];
			//后续需处理默认是多选的情况，因为默认多选是不需要设置选中的
			entityInfo.selectedRecords.push(nowRecords[0]);
			for (var i = 0; i < nowRecords.length; i++) {
				//索引标识
				var iden = v3patform.genUUID();
				var record = nowRecords[i];
				datas[iden] = record;
				//监听字段数据
				watchFieldData(instance, dsName, iden);
			}
			//触发加载事件
			fireEvent(instance,entityInfo.load,nowRecords);
		}

		//3、监听实体数据变化
		instance.$watch(dsName, function (newRecord) {
			debugger;
			try{
				//旧数据信息
				var oldRecordInfos = this.V3_PLATFORM_ENTITY_DATAS_INFO_IDEN[dsName];
				//旧数据
				var oldRecords = [];//数据
				var data_mappings = {};//数据 --> 索引
				var oldDatas = oldRecordInfos.datas;//索引 --> 数据
				for(var key in oldDatas){
					oldRecords.push(oldDatas[key]);
				}
				var insertRecords = [];
				var deleteRecords = [];
				var selectedRecords = oldRecordInfos.selectedRecords;
				//1、筛选出新增的数据
				if(newRecord && newRecord.length > 0){
					for(var i = 0,len = newRecord.length;i<len;i++){
						var record = newRecord[i];
						if(oldRecords.indexOf(record) == -1){//新增
							insertRecords.push(record);
						}
					}
				}
				//2、筛选出删除的数据
				for(var i = 0,len = oldRecords.length;i<len;i++){
					var record = oldRecords[i];
					if(newRecord.indexOf(record) == -1){//删除
						deleteRecords.push(record);
					}
				}
				var updateCurrent = false;
				var selectedChange = false;
				//3、处理删除
				if(deleteRecords.length > 0){
					var destroys = oldRecordInfos.destroys;
					for(var i = 0,len = deleteRecords.length;i<len;i++){
						var record = deleteRecords[i];
						if(oldRecordInfos.currentRecord === record){//删除了当前行
							updateCurrent = true;
						}
						var selIndex = selectedRecords.indexOf(record);
						if(selIndex != -1){//删除了选中
							selectedRecords.splice(selIndex,1);
							selectedChange = true;
						}
						for(var iden in oldDatas){
							if(record === oldDatas[iden]){
								var destroy = destroys[iden];
								try{
									//销毁记录监听
									if(typeof(destroy) == "function"){
										destroy();
									}
									delete oldDatas[iden];
									break;
								}catch(e){ }
							}
						}
					}
				}
				//4、处理新增
				if(insertRecords.length > 0){
					updateCurrent = true;
					for(var i = 0,len = insertRecords.length;i<len;i++){
						var record = insertRecords[i];
						var iden = v3patform.genUUID();
						oldDatas[iden] = record;
						//监听字段数据
						watchFieldData(instance, dsName, iden);
					}
				}

				//5、触发事件 当前行/选中行事件 没有记录则都不触发
				if(newRecord.length > 0){
					//处理当前行、选中行
					var currentRecord = newRecord[newRecord.length - 1];
					oldRecordInfos.currentRecord = currentRecord;
					if(oldRecordInfos.isMultipleSel === false){
						if(oldRecordInfos.selectedRecords.indexOf(currentRecord) == -1){
							selectedChange = true;
							oldRecordInfos.selectedRecords.push(currentRecord);
						}
					}
					if(insertRecords.length > 0){
						if(insertRecords.length > 1 || deleteRecords.length > 0){//属于直接赋值一个新数组
							//触发加载事件
							fireEvent(instance,oldRecordInfos.load,nowRecords);
						}else if(insertRecords.length == 1){
							//当期行事件
							fireEvent(this, oldRecordInfos.currentChange, [oldRecordInfos.currentRecord]);
							if(selectedChange){
								//选中行事件
								fireEvent(this, oldRecordInfos.selectionChange, [oldRecordInfos.selectedRecords]);
							}
						}
					}else if(deleteRecords.length > 0){
						//当期行事件
						fireEvent(this, oldRecordInfos.currentChange, [oldRecordInfos.currentRecord]);
						//选中行事件
						fireEvent(this, oldRecordInfos.selectionChange, [oldRecordInfos.selectedRecords]);
					}
				}
			}catch(e){
				if(window && window.console){
					window.console.error("处理数据错误." + e);
				}
			}finally{
				this._$V3PlatformDataHandlerIden = false;
			}
		}, {
			deep: false,
			sync: true
		});
	}
}

/**
 * 触发事件
 * @param {Object} instance 执行实例
 * @param {Array} events 事件列表
 * @param {Object} params 事件参数
 */
function fireEvent(instance,events,params){
	for(var i = 0,len = events.length;i<len;i++){
		var event = events[i];
		if(typeof(event) == "function"){
			event.apply(instance, params);
		}
	}
}
function getCreateFunc(params,type){
	//获取事件
	var _registerDsEvent = registerDsEvent;
	return function(){
		var _this = this;
		var events = getEventInfos(params,_this,type);
		if(!v3patform.isRunInV3Service()){//非v3服务添加数据源监听
			var dsName = params.prop.name;
			switch(type){
				case "record":
					handlerLocalEntityRecord(events,dsName, _this);
					break;
				case "cell":
					handlerLocalEntityCell(events,dsName, _this);
					break;
				default:
					//本地数据的处理方法
					handlerLocalEntity(events,dsName, _this);
					break;
			}
		}else{
			events.forEach(function(event, index){
				var _event = event;
				event.vueObj = _this;
				_registerDsEvent(event);
			});
		}
	}
}
function getEventInfos(params,_this,type){
	var eventInfo = params.event;
	var dsName = params.prop.name;
	var events = [];
	if(eventInfo){
		for(var key in eventInfo){
			if(eventInfo.hasOwnProperty(key)){
				var info = getEventInfo(eventInfo[key],key,_this,type);
				if(info){
					info.controlType=type;
					info.dsName = dsName;
					events.push(info);
				}
			}
		}
	}

	/**
	 * datasource的mixins默认注册列的值变化事件
	 * 避免自定义change的handler时将列的值变化事件覆盖
	 */
	if (type === 'datasource') {
		const columnChangeEvent = {
			eventType: 'change',
			controlType: type,
			dsName: dsName,
			name: 'on-cell-change',
			handler: function (changeDatas, allDatas) {
				columnValueChange(changeDatas, allDatas, _this);
			}
		}
		events.push(columnChangeEvent);
	}
	
	return events;
}
function getEventInfo(data, type, _this,controlType){
	var _default = {
		"load":{
			name:"on-load",
			handler:function(){
				_this.$emit("on-load");
			}
		},
		"change":{
			name:"on-change",
			handler:function(){
				_this.$emit("on-change");
			}
		},
		"currentChange":{
			name:"on-current-change",
			handler:function(){
				_this.$emit("on-current-change");
			}
		},
		"selectionChange":{
			name:"on-selection-change",
			handler:function(){
				_this.$emit("on-selection-change");
			}
		}
	}
	var eventlist = {
		"datasource":["load","change","currentChange","selectionChange"],
		"record":["load","change"],
		"cell":["load","change"]
	}
	var result = null;
	if(null != data && _default[type] && eventlist[controlType] && eventlist[controlType].indexOf(type)!=-1){
		var _defaultInfo = _default[type];
		var baseHandler =  _defaultInfo.handler;
		if(typeof(data) == "boolean"){
			if(data === true){
				result = {
					eventType:type,
					eventName:_defaultInfo.name,
					vueObj: _this,
					handler:baseHandler
				}
			}
		}else if(typeof(data) === "object"){
			var dataName = data.name;
			result = {
				eventType: type,
				vueObj: _this,
				eventName: _defaultInfo.name
			}
			if(dataName){
				baseHandler = function(){
					_this.$emit(dataName);
				}
				result.eventName = dataName;
			}
			//定义了handler，只执行handler 处理执行handler时，this指向为非当前组件的问题
			result.handler = typeof(data.handler) != "function" ? baseHandler : function(){
				data.handler.apply(_this, arguments);
			};
		}
	}
	return result;
}

/**
 * 列的值变化事件
 * @param {*} args 
 * @param {*} _this 
 */
const columnValueChange = function (changeDatas, allDatas, _this) {
	let columnChangeHandlers = _this[columnHandlerKey];
	let datas = changeDatas;
	// let oldDatas = args.oldResultSet.datas;
	if (datas && datas.length > 0 && columnChangeHandlers) {
		for (let i = 0, len = datas.length; i < len; i++) {
			const data = datas[i];
			const changeData = data;
			const changeKeys = Object.keys(changeData);
			if (changeKeys && changeKeys.length > 0) {
				changeKeys.forEach(function (changeKey) {
					let columnChangeHandler = columnChangeHandlers[changeKey];
					if (columnChangeHandler) {
						const newVal = changeData[changeKey];
						// const oldVal = oldDatas[i][changeKey];
						columnChangeHandler(newVal, data);
					}
				})
			}
		}
	}
}

var registerDsEvent = function(params){
	var vue = params.vueObj;
	if(typeof(vue.$root._$registerDsEvent) == 'function'){
		vue.$root._$registerDsEvent(params);
	}
	return false;
}

/*
{
	prop:{
		//属性名称
		name:'dataSource',
		//是否必填
		required:true/false,
		//默认值
		default:{},
		//校验函数
		validator:function
	},
	event:{
		//数据加载事件
		load:false/true/{
			name:'on-load',
			handler:function
		},
		//值改变事件
		change:false/true/{
			name:'on-change'
		}
	}
}
*/


function getProps(params,type){
	var types = {
		"datasource":{
			type: Array,
			v3PropType: "datasource",
			default:[]
		},
		"record":{
			type: Object,
			v3PropType: "record",
			default:{}
		},
		"cell":{
			type: [String , Number, Boolean],
			v3PropType:"cell",
			default:null
		}
	}
	var dsName = params.name;
	var typeInfo = types[type];
	var _default = params.default ? params.default : typeInfo.default;
	var props = {};
	props[dsName] = {
		type: typeInfo.type,
		v3PropType: type,
		required: params.required === true ? true : false,
		default: function(_d){
			return function(){
				return _d;
			}
		}(_default),
		validator: typeof(params.validator) == "function" ? params.validator : null
	}
	return props;
}
function check(params,type){
	if(type == "cell")
		return true;
	if(params && params.prop && params.prop.name){
		return true;
	}
	return false;
}
var mixins = {
	DatasourceMixin: DatasourceMixin,
	RecordMixin: RecordMixin,
	CellMixin: CellMixin
}
export default{
    mixins: mixins
}


// WEBPACK FOOTER //
// ./src/V3Vue.js